__turbopack_context__.v({
  "apple": "MgmrfG_apple",
  "buttonSecondaryColours": "MgmrfG_buttonSecondaryColours",
  "buttonTextColours": "MgmrfG_buttonTextColours",
  "component": "MgmrfG_component",
  "facebook": "MgmrfG_facebook",
  "google": "MgmrfG_google",
  "half": "MgmrfG_half",
  "inline-center": "MgmrfG_inline-center",
  "max-width": "MgmrfG_max-width",
  "menu-btn": "MgmrfG_menu-btn",
  "modal": "MgmrfG_modal",
  "mw-178": "MgmrfG_mw-178",
  "outline": "MgmrfG_outline",
  "outline--home": "MgmrfG_outline--home",
  "plain": "MgmrfG_plain",
  "primary": "MgmrfG_primary",
  "primary--home": "MgmrfG_primary--home",
  "shimmer": "MgmrfG_shimmer",
  "skeleton": "MgmrfG_skeleton",
  "startover": "MgmrfG_startover",
  "sticky": "MgmrfG_sticky",
  "submit-icon": "MgmrfG_submit-icon",
});
